export const en = {
  skipLink: 'Take me to my profile',
  stepOf: 'Step %{current} of %{total}',
  steps: {
    myDynamics: {
      title: 'Your Energy Map',
      cta: 'Continue',
      skip: 'Skip this step',
      introductionTitle: 'Introduction',
      intensitiesTitle: 'Energy Intensities',
      dynamicsTitle: 'The 4 Energies',
      introBody:
        'Hi, %{firstName}! You are what we refer to as %{energyType}, which you will learn all about on your profile page. Before you get to that, the next few slides will walk you through a few of the capabilities of the platform to ensure you get the most value out of Simpli5. If you would rather head straight to your profile and explore it on your own, simply click "Take me to my profile" in the upper right-hand corner. Otherwise, use the Continue button below to finish going through the set up.',
    },
    networkReveal: {
      title: "See who's already here",
      cta: 'Continue',
      skip: 'Skip this step',
      orgBanner: '%{count} colleagues have already set up Simpli5 profiles.',
      platformBanner: 'Join %{count} others on the Simpli5® platform',
      connect: 'Connect',
      connecting: 'Connecting…',
      connected: 'Request Sent!',
      pending: 'Request Pending',
      loadMore: 'Load More',
      loadingMore: 'Loading…',
      publicFooterNote: "You can view %{firstName}'s full profile later at the Network page.",
      privateFooterNote: "%{firstName}'s profile is set to private. Connect for permission to view.",
    },
    workingCircle: {
      title: 'Build your working circle',
      tagline:
        'Build your Working Circle for at-a-glance insights of your closest colleagues right from your homepage.',
      prompt: 'Who do you work with most closely?',
      searchPlaceholder: 'Search by name or email…',
      searching: 'Searching…',
      adding: 'Adding…',
      remove: 'Remove %{name}',
      cta: 'Set Up My Circle',
      ctaDisabled: 'Add at least one colleague',
      skip: 'Skip for now',
      inviteLink: 'Invite someone not on Simpli5',
      inviteTitle: 'Send a Simpli5 invite',
      inviteFirstName: 'First name',
      inviteLastName: 'Last name',
      inviteEmail: 'Work email',
      inviteSend: 'Send Invite',
      inviteCancel: 'Cancel',
      inviteConfirmTitle: 'Send %{name} an invite?',
      inviteConfirmBody: "They'll be added to your working circle once they join Simpli5.",
      inviteConfirmYes: 'Yes, Send Invite',
      inviteConfirmBack: 'Go Back',
      inviteSending: 'Sending…',
      invitePending: 'Invited',
      inviteErrorEmail: 'Please enter a valid email address.',
      inviteErrorLimit: "You've reached the daily invite limit. Try again tomorrow.",
      privateProfileError: "This colleague's profile is private. Send them a connection request first.",
      inviteBlockSso:
        'Your organization uses SSO to access Simpli5. Ask other team members to join using your SSO dashboard.',
      inviteBlockAdminOnly:
        'Contact your account admin (the person who invited you to join) to request other team members be invited.',
      inviteBlockDismiss: 'Dismiss',
    },
    pairReport: {
      title: 'Explore your first pair report',
      cta: 'View Pair Report',
      ctaWithName: 'View Pair Report with %{name}',
      skip: 'Skip this step',
      loading: 'Finding a colleague for you…',
      prompt: 'See how you and %{name} work together',
      chooseDifferent: 'Choose someone else',
      searchPlaceholder: 'Search by name or email…',
      searching: 'Searching…',
      noSuggestion: 'No colleagues have completed their assessment yet',
      limitedMemberWarning: "This colleague hasn't upgraded yet. Choose someone else or invite them.",
      currentUserLimitedMemberWarning: 'Upgrade to Pro to view pair reports.',
    },
  },
}

export const es = en
